import React from "react"

import PopoverMenuItem from "../../../../../../../core/gd-components/popover-menu/popover-menu/menu-item"

export default function DocPageMoreMenu(props: {
    menuParams  : any,
    hidePopover : any, //callback
}) {

    const onDelete = () => {
        props.menuParams.onDelete()
        props.hidePopover()
    }

    return (
        <div className="ui5-popover-menu">
            <PopoverMenuItem icon="i5-trash-alt" label="Delete" onClick={onDelete}/>
        </div>
    )
}